import { useDesignMaxTheme } from "@/packages";
import { useGetCommon, type RoomPreviewInfoResponse } from "@/shared/server";
import { Box, Center, chakra, Spinner, Text } from "@chakra-ui/react";
import { easeOut, motion } from "framer-motion";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { RoomDetail } from "./components";

export const RoomPreview = () => {
    const { data } = useGetCommon<RoomPreviewInfoResponse>({ section: "rooms_S4" });
    const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const [currentIdx, setCurrentIdx] = useState(0);
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const nextSlide = () => {
        setCurrentIdx((prev) => (prev === (data?.currentRooms.length as number) - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        setCurrentIdx((prev) => (prev === 0 ? (data?.currentRooms.length as number) - 1 : prev - 1));
    };

    return data ? (
        <Box position="relative" width="100%" h="100dvh" ref={ref} p={isMobile ? "64px 0 24px 0" : "0"}>
            {data.currentRooms.map((room, index) => (
                <MotionBackground
                    key={room.roomIdx}
                    position="absolute"
                    w="100%"
                    h="100%"
                    top="0"
                    background={`url(${room.imgList[0].imgUrl}) no-repeat center/cover`}
                    pointerEvents={index !== currentIdx ? "none" : "auto"}
                    initial={{ opacity: index === currentIdx ? 1 : 0 }}
                    animate={{ opacity: index === currentIdx ? 1 : 0, transition: { duration: 1, ease: easeOut } }}
                />
            ))}
            <RoomDetail
                inView={inView}
                data={data}
                currentIdx={currentIdx}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
            />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};

const MotionBackground = chakra(motion.div);
